import { handleActions } from 'redux-actions';
import { initialize as initializeForm } from 'redux-form';
import { NotificationManager } from "react-notifications";
import { api } from "api";
import Swal from 'sweetalert2';
import moment from 'moment';

const LISTADO_ND = 'LISTADO_ND';
const NOTA_DEBITO = 'NOTA_DEBITO';
const DETALLE_ND = 'DETALLE_ND';
const LOADER = 'LOADER';
const MODULO = 'MODULO';
const PERIODO_D = 'PERIODO_D';
const PARAMETRO = 'PARAMETRO';
const LOADERC = 'LOADERC';
const DETALLE = 'DETALLE';

const setLoader = loader => ({
    type: LOADER,
    loader,
});

export const listar = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    let id_period = id_emp[7];
    const params = { id, id_period };
    dispatch(setLoader(true));
    api.get('/distribuidor/nota_debito_planilla', params).then((response) => {
        dispatch({ type: LISTADO_ND, data: response });
    }).catch((error) => {
        NotificationManager.error(
            'Ocurrió un error al listar notas de débito',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const leerPeriodoD = (id, id_periodo) => (dispatch) => {
    const params = { id, id_periodo };
    api.get('/periodos/periodo', params).then((response) => {
        dispatch({ type: PERIODO_D, periodoD: response.periodo });
    }).catch((error) => {
        NotificationManager.error(
            'Ocurrió un error al consultar periodo',
            'Error',
            2000
        );
    })
}

export const getModulo = (id, modulo) => (dispatch) => {
    const params = {id, modulo}
    dispatch(setLoader(true));
    api.get('/modulos/modulo/', params).then((response)=>{
        dispatch({ type: MODULO, modulo: response.modulos });
    }).catch(() => {
        NotificationManager.error(
            'Ocurrió un error en buscar modulo',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

export const parametrosEmpresa = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    const params = {id}
    dispatch(setLoader(true));
    api.get('/empresa/empresa_parametros', params).then((response) => {
        dispatch({type: PARAMETRO, datos: response });
    }).catch((error)=>{
        
        NotificationManager.error(
            'Ocurrió un error al consultar parametros',
            'Error',
            8000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });

}

export const listarDistribuidor = (search) => () => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    const params = {id, search}
    return api.get('/distribuidor/distribuidor',params).then(data=>{
        const list_distribuidor = [];
        if(data){
            data.forEach(item=>{
                list_distribuidor.push({
                    value: item.id + '#' + item.nombre_pais + '#' + item.codigo_pais + '#' + item.pais,
                    label: item.nombre
                })
            })
        }
        return list_distribuidor ;
    }).catch((error)=>{
        
        return [];
    })
}

const actualizar = () => (dispatch, getStore) => {
    const data = getStore().form.FormNotaDebitoVM.values;
    dispatch(initializeForm(
        'FormNotaDebitoVM', {
            ...data,
            tipo_gasto: null,
            cuenta: null
    }));
    dispatch({ type: DETALLE, detalleDocN: data.detalleD });
};

export const registroNotaDebito = (data = {}, attachments = [], periodoD, paisD, paisID) => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const data = getStore().form.FormNotaDebitoPlanillaVM.values;
    if (data === undefined){
        Swal.fire({
            title: 'Nota de débito',
            text: 'Seleccione distribuidor',
            type: 'error',
        })
    }else{
        if (data.fecha_registro === '' || data.fecha_registro === undefined){
            Swal.fire({
                title: 'Nota de débito',
                text: 'Ingrese fecha',
                type: 'error',
            })
        }else{
            let fechaI = moment(periodoD.fecha_inicio);
            let fechaF = moment(periodoD.fecha_fin);
            let fecha = moment(data.fecha_registro);
            if (fecha>=fechaI && fecha<=fechaF){
                if (data.numero === '' || data.numero === undefined || data.numero === 0){
                    Swal.fire({
                        title: 'Nota de débito',
                        text: 'Ingrese numero',
                        type: 'error',
                    })
                }else{
                    if (data.tipo === '' || data.tipo === undefined){
                        Swal.fire({
                            title: 'Nota de débito',
                            text: 'Seleccione tipo de nota débito',
                            type: 'error',
                        })
                    }else{
                        let dist = data.distribuidor.value.split('#');
                        const formData = {
                            fecha_registro: data.fecha_registro,
                            descripcion: data.descripcion,
                            distribuidor: dist[0],
                            tipo: data.tipo,
                            numero: data.numero,
                            empresa: id_emp[5],
                            periodo: id_emp[7],
                            pais: paisD,
                            idPais: paisID
                        }
                        dispatch(setLoader(true));
                        api.postAttachments('/distribuidor/nota_debito_planilla/planilla_excel/', formData, attachments).then(() => {
                            NotificationManager.success(
                                'Nota de débito creado correctamente',
                                'Exito',
                                3000
                            );
                            setTimeout(function () {
                                window.location.reload(true);
                            }, 2000);
                        }).catch((error) => {
                            NotificationManager.error(
                                error.msj,
                                'Error',
                                2000
                            );
                        }).finally(() => {
                            dispatch(setLoader(false));
                        });
                    }
                }
            }else {
                Swal.fire({
                    title: 'Nota de débito',
                    text: 'Fecha fuera del periodo',
                    type: 'error',
                })    
            }
        }
    }
}

export const leer = (id) => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`/distribuidor/nota_debito_planilla/${id}`).then((response) => {
        dispatch({ type: NOTA_DEBITO, lectura: response });
        dispatch(initializeForm('FormNotaDebitoPlanillaVM', response ));
        dispatch(leerDetalleND(response.id));
    }).catch((error)=>{
        NotificationManager.error(
            'Ocurrió un error al consultar nota de débito',
            'Error',
            8000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });

}

const leerDetalleND = (id_nota ) => (dispatch) => {
    api.get(`/distribuidor/nota_debito_detalle_planilla/${id_nota}`).then((response)=>{
        dispatch({ type: DETALLE_ND, detalleND: response });
    }).catch((error)=>{
        NotificationManager.error(
            'Ocurrió un error',
            'Error',
            0
        );
    })
};

const eliminarND = id => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    dispatch(setLoader(true));
    api.eliminar(`/distribuidor/nota_debito_planilla/${id}`).then(() => {
        dispatch(listar(id_emp[7]));
        NotificationManager.success(
            'Nota débito borrada correctamente',
            'Exito',
            3000
        );
    }).catch(() => {
        NotificationManager.error(
            'Ocurrió un error en eliminar nota débito',
            'Error',
            0
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

export const actions = {
    leer,
    listar,
    leerPeriodoD,
    getModulo,
    parametrosEmpresa,
    listarDistribuidor,
    actualizar,
    registroNotaDebito,
    eliminarND
};

export const reducers = {
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [LISTADO_ND]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [NOTA_DEBITO]: (state, { lectura }) => {
        return {
            ...state,
            lectura,
        };
    },
    [DETALLE_ND]: (state, { detalleND }) => {
        return {
            ...state,
            detalleND,
        };
    },
    [MODULO]: (state, { modulo }) => {
        return {
            ...state,
            modulo,
        };
    },
    [PERIODO_D]: (state, { periodoD }) => {
        return {
            ...state,
            periodoD,
        };
    },
    [PARAMETRO]: (state, { datos }) => {
        return {
            ...state,
            datos,
        };
    },
    [LOADERC]: (state, { loaderC }) => {
        return {
            ...state,
            loaderC,
        };
    },
    [DETALLE]: (state, { detalleDocN }) => {
        return {
            ...state,
            detalleDocN,
        };
    },

};

export const initialState = {
    loader: false,
    lectura: [],
    modulo: [],
    periodoD: [],
    data: [],
    datos: [],
    loaderC: false,
    detalle: [],
    detalleND: [],
    data: [],
    lista_cuentas: [],
    page: 1,
    cuentaContable: [],
    gastos: []
};

export default handleActions(reducers, initialState)